

// for navbar
export const Links=[
    {
        id:1,
        link:"Home",
        path:'/'
    },
    {   
        id:2,
        link:"Blog",
        path:'/blog'
    },
    {
        id:3,
        link:"Profile",
        path:'/biography'
    },
    {
        id:4,
        link:"Contact",
        path:'/contact'
    },
    {
        id:5,
        link:"Chatbot",
        path:'/chatbot'
    },
    
]


// for services
export const Services=[
    {
        id:1,
        icon:"fas fa-code",
        column:'WEB DESIGN AND DEVELOPMENT USING HTML&CSS AND ALL OTHER JAVASCRIPT LIBRARIES AND DEPENDENCIES',
        text:"We make use of HTML&CSS together with all JAVASCRIPT libraries, runtimes and frameworks such as NODE.JS, JQUERY, REACTJS, ANGULARJS and many more to create the ultimate fully responsive website for your businesses and products. We are also available for tutorship if you wish to know the secrets to becoming a full stack proffessional web developer."
    },
    {   
        id:2,
        icon:"fas fa-gamepad",
        column:'GAME DESIGN',
        text:"With the use of C++, C# and other powerful programming languages and development tools like UNITY, we are able to provide you with the skills needed to become a proffessional game developer"
    },
    {
        id:3,
        icon:"fas fa-laptop",
        column:'MACHINE LEARNING AND DATA SCIENCE',
        text:"With the use of python, we impliment various machine learning algorithms such as linear regression, logistic regression, Naive bayes and many other powerful and effective machine learning algorithms to train models, and are able to teach you what it means to be a machine learning and data science scientist, after which you would be able to apply your knowledge to real life problems"
    },
    {
        id:4,
        icon:"fas fa-robot",
        column:'ROBOTICS',
        text:"with the application of Trigonometry, Electrical Engineering, and Mechanical Engineering and a bit of machine learning, we are able to provide you with the skills needed to become a robotics engineer. Giving you the understanding of the physics behind the creation of a robot and how it functions, such as its mobility."
    },
    
  
  
]

// for services
export const Portfolio=[
    {
        id:1,
        img:require("../../images/portfolio.jpeg"),
        plus:"fas fa-plus"
       
    },
    {
        id: 2,
        img:require("../../images/tools.jpg"),
        plus: "fas fa-plus"

    },
    {
        id: 3,
        img: require("../../images/portfolio2.jpg"),
        plus: "fas fa-plus"

    },
    {
        id: 4,
        img: require("../../images/portfolio3.jpeg"),
        plus: "fas fa-box"

    },
  
  
]


// for blogs
export const blogItems=[
    {
        id:1,
        img:require("../../images/tech.jpeg"),
        date:"30 February 2020",
        title:'Innovation',
        words:'Bringing you the latest trending news about technology and how technology is taking over the world. With the merging of machine learning with circuits and mechanics, we can actually create robots that can display similar attributes and characteristics to humans in being able to arrive at a solution to a problem provided there is available data to learn from. We can also observe how machine learning is dominating the industry in terms on what we use our phones to do all the time. When we access the internet, we are using the result of a machine learning algorithm whether directly or indirectly.',
        number1:"896",
        number2:"5648",
    
       
    },
    {   
        id:2,
        img:require("../../images/tech2.jpeg"),
        date:"12 April 2020",
        title:'New trends',
        words:"For a while now, it has been observed that machine Learning is fast becoming the science on which mankind is fast basing it's existence on. With the emergence of youtube, netflix and all other social media platforms which were all built using python and powerful machine learning algorithms such as logistic regression, linear regression, naive bayes, random forest and many more, we can say that entertainment is a factor affecting human life and it is needed to keep the balance with these social media platforms doing just that and alot more.",
        message:'fas fa-comment',
        number1:"1896",
      number2:"35648",
     
    },
    {
        id:3,
        img:require("../../images/tech4.jpeg"),
        date:"10 August 2020",
        title:'Follow the future',
        words:"Taking a quick peek at the what we are to expect from technology in the future, we would see that we have barely only scratched the surface of Artificial Intelligence. Artificial Intelligence can be divided into three, which are; artificial narrow intelligence (ANI), artificial general intelligence (AGI), and artificial super intelligence (ASI).",
        words2:"Artificial Narrow Intelligence is a science whereby machines which are trained to execute task posses a narrow range of abilities. Such abilities are exibited in the technology we can see today such as self driving cars, classification of emails into spam and non-spam, autonomous robotics etc. We are still in the age of ANI, but we are fast evolving into AGI. ",
        words3:"Artificial General Intelligence is a science whereby the intelligence of machines is expected to be on par with that of humans. However there have been some limitations with scientists achieving this feat because there is always a problem with computation and algorithms, because a machine cannot do outside what it has been programed or trained to do. Further research is being done in order to achieve this feat.",
        words4:"Artificial Super Intelligence is a science whereby a machines ability to think and reason is expected to exceed or surpass that of a human. This is something we have actually only seen in the movies, but scientists are hoping and are working towards actually making this dream a reality.",
        words5:"My final take on the matter is that robots are the future of mankind. Because having robots around makes things alot easier and allows jobs and projects to be executed alot more faster and more efficiently..",
        message:'fas fa-comment',
        number1:"1236",
       number2:"3648",
        
    },
    {
        id:4,
        img:require("../../images/young-man-with-laptop-sitting-floor_23-2147577277.jpg"),
        date:"",
        words:"Heyo!",
    },
   
  
]




// famous interiors
export const Interiors=[
    {
        id:1,
        name:'John Jones',
        img:"images/interiors/interior1.png",
       
    
       
    },
    {   
        id:2,
        name:'mika jack',
        img:"images/interiors/interior2.png",
        
     
    },
    {
        id:3,
        name:'lara stone',
        img:"images/interiors/interior3.png",
      
    },
    {
        id:4,
        name:'conor brad',
        img:"images/interiors/interior4.png",
      
    },
   
   
  
]



// recent events
export const Events=[
    {
        id:1,
       name:'John Jones',
       date:"01-03-2020",
       area:'athens'
       
    
       
    },
    {   
        id:2,
        name:'mika jack',
        date:"22-03-2020",
        area:'Chalcis'
        
     
    },
    {
        id:3,
        name:'sara conor',
        date:"22-05-2020",
        area:'Sallonika'
      
    },
    {
        id:4,
        name:'mika jack',
        date:"17-06-2020",
        area:'Athens'
      
    },
    {
        id:5,
        name:'carla jameson',
        date:"27-06-2020",
        area:'giannena'
      
    },
    {
        id:6,
        name:'John best',
        date:"04-07-2020",
        area:'Athens'
      
    },
    {
        id:7,
        name:'clara sant',
        date:"17-08-2020",
        area:'trikala'
      
    },
    {
        id:8,
        name:'michel jonas',
        date:"28-086-2020",
        area:'salonka'
      
    },
    {
        id:9,
        name:'mika jack',
        date:"23-09-2020",
        area:'Athens'
      
    },
    {
        id:10,
        name:'zina cloud',
        date:"17-10-2020",
        area:'Athens'
      
    },
   
   
  
]





